/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {AnalyticsService} from './@core/utils/analytics.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private titleService: Title,
    private analytics: AnalyticsService,
    translate: TranslateService,
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
    translate.reloadLang('en');
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    let url = window.location.href;
    if (url.includes('sinecta')) {
      this.titleService.setTitle('Sinecta');
    } else {
      this.titleService.setTitle('ANA-IA');
    }
  }
}
